import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Icon, { NAMES } from '@ifit/react-icons';
import MuiIconButton from 'material-ui/IconButton';
import MuiRaisedButton from 'material-ui/RaisedButton';
import { onboardingCompleted } from '../../../store/ducks/user';
import { setNavigationFlow } from '../../../store/ducks/navigation-flow';
import SettingsContainer from '../../../components/settings-container';
import styles from '../../../shared-styles';
import { Navigation } from '../../../navigation/react-redux-nav';
import { white80 } from '../../../theme/colors';
import './index.css';

export class PureConfirmYourFormula extends Component {
  confirmFormula = () => {
    this.props.confirmFormula(this.props.connectedProduct);
  }

  getWeight = (metricWeight, units, includeDecimals) => {
    let displayWeight = units === 'metric' ? metricWeight : metricWeight * 2.21;
    if (displayWeight % 1 !== 0 && includeDecimals) {
      displayWeight = displayWeight.toFixed(2);
      displayWeight = parseFloat(displayWeight);
    } else {
      displayWeight = Math.round(displayWeight);
    }
    const displayUnit = units === 'metric' ? 'kg' : 'lb';
    return `${displayWeight} ${displayUnit}`;
  }

  getGoalDate = (weight, goalWeight, targetWeightMetric) => {
    if (!targetWeightMetric) return '';
    const weeks = (goalWeight - weight) / targetWeightMetric;
    const goalDate = new Date();
    goalDate.setDate(goalDate.getDate() + weeks * 7);
    const splitDate = goalDate.toDateString().split(' ');
    return `${splitDate[1]} ${splitDate[2]}, ${splitDate[3]}`;
  }

  getCalorieRequirement = () => {
    const burnOrIntake = this.props.targetWeightChange < 0 ? 'burn' : 'intake';
    const calories = Math.abs(this.props.targetWeightChange) * 500;
    return `You'll need to ${burnOrIntake} ${calories} more calories each day.`;
  }

  setConfirmFormulaFlow = () => {
    this.props.setFlow({ flowType: 'confirmFormula' });
  }

  render() {
    const { weight, goalWeight, targetWeightChange, units } = this.props;
    const targetWeightMetric = weight === goalWeight ? 0 : targetWeightChange;
    const gainOrLose = weight < goalWeight ? 'gain' : 'lose';
    return (
      <SettingsContainer
        className="confirm-formula-page"
        pageTitle="Confirm your formula."
        hideNavigation
        hideSkip
        isValid
      >
        <div className="formula-stat-row">
          <p>Each week, you want to { gainOrLose }:</p>
          <h2>{ this.getWeight(Math.abs(targetWeightMetric), units, true) }</h2>
          <Navigation.JumpTo page="current-weight" onClick={ this.setConfirmFormulaFlow }>
            <MuiIconButton
              className="formula-edit"
              style={{ position: 'absolute' }}
            >
              <Icon
                name={ NAMES.EDIT }
                color={ white80 }
                size={ 18 }
                unitSize="px"
              />
            </MuiIconButton>
          </Navigation.JumpTo>
        </div>
        <div className="formula-stat-row">
          <p>To achieve your goal weight of:</p>
          <h2>{ this.getWeight(goalWeight, units) }</h2>
        </div>
        <hr />
        {
          targetWeightMetric ?
            <div>
              <div className="formula-stat-row">
                <p>You will achieve this goal by:</p>
                <h2>{ this.getGoalDate(weight, goalWeight, targetWeightMetric) }</h2>
              </div>
              <p className="formula-stat-summary">{ this.getCalorieRequirement() }</p>
            </div>
            : null
        }
        <div className="formula-button-container">
          <MuiRaisedButton
            onClick={ this.confirmFormula }
            className="formula-confirm-button"
            label="Confirm"
            primary={ false }
            fullWidth={ true }
            style={ styles.buttonStyle }
            labelStyle={ styles.buttonLabelStyle }
          />
        </div>
      </SettingsContainer>
    );
  }
}

PureConfirmYourFormula.propTypes = {
  weight: PropTypes.number.isRequired,
  goalWeight: PropTypes.number.isRequired,
  targetWeightChange: PropTypes.number.isRequired,
  units: PropTypes.string.isRequired,
  connectedProduct: PropTypes.string,
  confirmFormula: PropTypes.func.isRequired,
  setFlow: PropTypes.func.isRequired,
};

export default connect(
  state => ({
    weight: state.user.weight,
    goalWeight: state.user.goal_weight,
    targetWeightChange: state.user.target_weight_change,
    units: state.user.units,
    connectedProduct: state.connectedProduct,
  }),
  dispatch => ({
    confirmFormula: connectedProduct => dispatch(onboardingCompleted(connectedProduct)),
    setFlow: flowInfo => dispatch(setNavigationFlow(flowInfo)),
  }),
  null,
  { withRef: true }
)(PureConfirmYourFormula);
